import { Campaign } from 'src/apis/coupon'
import { Card, MemberLevels, PointHistory } from 'src/apis/profile'
import { MutationTree } from 'vuex'
import { MemberStateInterface } from './state'
import types from './types'
import { filter } from 'lodash'

const mutation: MutationTree<MemberStateInterface> = {
  [types.MEMBER_LOAD_DATA](state) {
    state.isLoadingCard = true
  },
  [types.MEMBER_LOAD_DONE](state, cards: Card[]) {
    state.availableCard = cards
    if (cards.length > 0) {
      state.currentCard = cards[0]
    }
    state.isLoadingCard = false
  },
  [types.MEMBER_LEVEL_LOAD_DONE](state, memberLevels: MemberLevels[]) {
    state.memberLevels = memberLevels
    
  },
  [types.MEMBER_LOAD_CAMPAIGN](state, card: number | null = null) {
    if (card) {
      const ins = filter(state.availableCard, (obj) => obj.id === card)
      if (ins) {
        state.currentCard = ins[0]
      }
    }
    state.isLoadingCampaign = true
  },
  [types.MEMBER_LOAD_CAMPAIGN_DONE](state, campaigns: Campaign[]) {
    state.campaigns = campaigns
    state.isLoadingCampaign = false
  },
  [types.SELECT_CAMPAIGN](state, campaign: Campaign) {
    state.selectedCampaign = campaign
  },
  [types.MEMBER_LOAD_HISTORY](state) {
    state.isLoadingHistory = true
  },
  [types.MEMBER_LOAD_HISTORY_DONE](state, history: PointHistory[]) {
    state.history = history
    state.isLoadingHistory = false
  },
}

export default mutation
